import React, { FC }                                                                                                             from 'react';
import * as Yup                                                                                                                  from "yup";
import { Cell, Grid }                                                                                                            from "styled-css-grid";
import { BulkUpdateFormControlContainer }                                                                                        from "@src/views/pages/projects/activities/bulk/BulkUpdateFormControlContainer";
import { ProjectActivityBulkUpdateShell, ProjectActivityBulkUpdateShellFormContainerProps, ProjectActivityBulkUpdateShellProps } from "@src/views/pages/projects/activities/bulk/ProjectActivityBulkUpdateShell";
import { ProjectActivityBulkUpdateMultiDialogProps }                                                                             from "@src/views/pages/projects/operations/ProjectActivityBulkUpdateMultiDialog";
import { ACTIVITY_STATUS, ENTITY_ICONS }                                                                                         from "@src/constants";
import _                                                                                                                         from "underscore";
import { useFeatureFlags }                                                                                                       from "@src/hooks";
import { InteropService }                                                                                                        from "@src/services";
import { CompletionStatusDropdown }                                                                                              from "@src/views/components/forms/dropdowns/CompletionStatusDropdown";
import { SelectField }                                                                                                           from "@src/views/components/forms";
import { formatOption }                                                                                                          from "@src/util";


type FormTypeAttributes = {
    isAtRisk: string,
}

const formDefaultValues = {
    isAtRisk: null,
}

const validationSchema = (
    Yup.object().shape( {
        isAtRisk: Yup.string().nullable()
    } )
)

const mutationAttributeFormatter: ProjectActivityBulkUpdateShellProps<FormTypeAttributes>['prepareFormValuesForMutation'] = ( values, formik ) => {

    const { isAtRisk } = values

    const changes: Record<any, any> = {};

    changes.isAtRisk = ( isAtRisk === 'true' );

    return changes;
}

interface StaticProjectActivityBulkUpdateIsAtRiskProps extends Pick<ProjectActivityBulkUpdateShellProps<FormTypeAttributes>, 'supportModals' | 'supportToasts'>,
    Pick<ProjectActivityBulkUpdateMultiDialogProps, 'projectId' | 'projectVersionId' | 'projectActivityIds'> {
    formContainer: FC<ProjectActivityBulkUpdateShellFormContainerProps>
}

const StaticProjectActivityBulkUpdateIsAtRiskDefaultProps = {
    supportModals: false,
    supportToasts: true,
} satisfies Partial<StaticProjectActivityBulkUpdateIsAtRiskProps>

function StaticProjectActivityBulkUpdateIsAtRisk( _props: StaticProjectActivityBulkUpdateIsAtRiskProps ){

    const props = { ...StaticProjectActivityBulkUpdateIsAtRiskDefaultProps, ..._props };

    const featureFlags = useFeatureFlags();

    return (

        <ProjectActivityBulkUpdateShell<FormTypeAttributes>
            projectId={ props.projectId }
            projectVersionId={ props.projectVersionId }
            ids={ props.projectActivityIds }
            supportToasts={ props.supportToasts }
            supportModals={ props.supportModals }
            defaultFormValues={ formDefaultValues }
            validationSchema={ validationSchema }
            formContainer={ props.formContainer }
            prepareFormValuesForMutation={ mutationAttributeFormatter }>

            {/* FORM CONTENT */ }
            { ( { formik, isProcessing, isLoading } ) => {

                return (

                    <BulkUpdateFormControlContainer
                        icon={ ENTITY_ICONS.ACTIVITIES.RISK_RATING }
                        title={ 'Update At Risk Status' }
                        description={ `Migrate the "At Risk" status for multiple activities to the one specified.` }>

                        <Grid columns={ `1fr` } rows={ `auto auto` } columnGap={ "30px" } rowGap={ '30px' }>
                            <Cell>

                                <SelectField
                                    label={ "Status" }
                                    descriptionText={ `The risk status for which these activities should be set to.` }
                                    name={ "isAtRisk" }
                                    options={[
                                        formatOption('false', 'None'),
                                        formatOption('true', 'At Risk'),
                                    ]}
                                    disabled={ isLoading || isProcessing }/>
                            </Cell>
                        </Grid>

                    </BulkUpdateFormControlContainer>

                )
            } }

        </ProjectActivityBulkUpdateShell>

    );
}

export {
    StaticProjectActivityBulkUpdateIsAtRisk,
    StaticProjectActivityBulkUpdateIsAtRiskDefaultProps,
    type StaticProjectActivityBulkUpdateIsAtRiskProps,
};
